import axios from "axios";
import store from "@/store";
import router from "@/router";
import qs from "qs";

// create an axios instance
const service = axios.create({
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    withCredentials: true,
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000, // request timeout
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
});


service.interceptors.request.use((config) => {
    // trigger 'loading=true' event here
    const token = localStorage.getItem("apiToken");
    config.headers["Authorization"] = `Bearer ${token}`;
    store.commit("SET_LOADING", true);
    return config;
}, (error) => {
    // trigger 'loading=false' event here
    store.commit("SET_LOADING", false);
    return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */
    response => {
        let res = response.data;
        let responseType = response.config.responseType;
        store.commit("SET_LOADING", false);
        // if download get headers
        if (responseType === "blob") {
            res = response;
        }
        // if the custom code is not 20000, it is judged as an error.
        if (/^2\d\d$/.test(response.status)) {
            return res;
        } else {
            // Error
            return Promise.reject(new Error(res.message || "Error"));
        }
    },
    error => {
        // console.log(error.response); // for debug
        if (!error.response && error.status != 401) {
            // network error
            store.commit("SHOW_DIALOG", {
                multiLine: true,
                multiLineTexts: ["サーバーエラーが発生しました。再度処理を行ってください。", "問題が解決しない場合は、システム管理者にお問い合わせください。"],
                icon: "mdi-information-outline",
                iconColor: "#e38f97",
                closeDialog: ""
            });
        } else if (error.response.status == 400) {
            return Promise.reject(error);
        } else if (error.response.status == 401 || error.status == 401) {
            // 401 のエラーをもらったら、ログイン画面に行く
            if (
                router.currentRoute.name !== "Login" &&
                router.currentRoute.name !== "AdminLogin"
            ) {
                if (router.currentRoute.path.startsWith("/admin")) {
                    router.push("/admin/401");
                } else {
                    router.push("/401");
                }
            }
            return Promise.reject(error);
        } else if (error.response.status == 403) {
            // 403エラー
            if (router.currentRoute.path.startsWith("/admin")) {
                router.push("/admin/403");
            } else {
                router.push("/404");
            }
        } else if (error.response.status == 404) {
            // 404エラー
            if (router.currentRoute.path.startsWith("/admin")) {
                router.push("/admin/404");
            } else {
                router.push("/404");
            }
        } else if (error.response.status == 500) {
            // 500エラー
            if (router.currentRoute.path.startsWith("/admin")) {
                router.push({ name: 'AdminSaverError' });
            } else {
                router.push({ name: 'SaverError' });
            }
        } else if (error.response.status == 503) {
            // 503エラー
            if (router.currentRoute.path.startsWith("/admin")) {
                router.push("/admin/503");
            } else {
                router.push("/503");
            }
        } else {
            store.commit("SHOW_DIALOG", {
                multiLine: true,
                multiLineTexts: ["サーバーエラーが発生しました。再度処理を行ってください。", "問題が解決しない場合は、システム管理者にお問い合わせください。"],
                icon: "mdi-information-outline",
                iconColor: "#e38f97",
                closeDialog: ""
            });
        }
        return Promise.reject(error);
    }
);

export default service;
